/**
 * 중앙 집중식 프로바이더 설정
 * 모든 프로바이더 정보를 한 곳에서 관리
 */

export const PROVIDERS = {
  // Slot Game Providers
  'pragmatic': {
    id: 'pragmatic',
    code: 'pragmatic',
    displayName: 'Pragmatic Play',
    koreanName: '프라그마틱 플레이',
    logoFile: 'vender-logo-pragmatic.png',
    characterFile: '/api/providers/characters/casino-pragmatic.png',
    category: 'slot',
    aliases: ['pragmatic play', 'pragmaticplay']
  },
  'netent': {
    id: 'netent',
    code: 'netent',
    displayName: 'NetEnt',
    koreanName: '넷엔트',
    logoFile: 'vender-logo-netent.png',
    category: 'slot',
    aliases: ['net ent']
  },
  'microgaming': {
    id: 'microgaming',
    code: 'microgaming',
    displayName: 'Microgaming',
    koreanName: '마이크로게이밍',
    logoFile: 'vender-logo-microgaming.png',
    characterFile: '/api/providers/characters/casino-mg.png',
    category: 'slot',
    aliases: ['micro gaming', 'mg']
  },
  'playngo': {
    id: 'playngo',
    code: 'playngo',
    displayName: "Play'n GO",
    koreanName: '플레이앤고',
    logoFile: 'vender-logo-playngo.png',
    category: 'slot',
    aliases: ["play'n go", "play n go", "playandgo"]
  },
  'yggdrasil': {
    id: 'yggdrasil',
    code: 'yggdrasil',
    displayName: 'Yggdrasil',
    koreanName: '이그드라실',
    logoFile: 'vender-logo-yggdrasil.png',
    category: 'slot',
    aliases: ['yggdrasil gaming']
  },
  'redtiger': {
    id: 'redtiger',
    code: 'redtiger',
    displayName: 'Red Tiger',
    koreanName: '레드 타이거',
    logoFile: 'vender-logo-redtiger.png',
    category: 'slot',
    aliases: ['red tiger gaming', 'redtigergaming']
  },
  'btg': {
    id: 'btg',
    code: 'btg',
    displayName: 'Big Time Gaming',
    koreanName: '빅타임 게이밍',
    logoFile: 'vender-logo-btg.png',
    category: 'slot',
    aliases: ['bigtimegaming', 'big time gaming']
  },
  'evoplay': {
    id: 'evoplay',
    code: 'evoplay',
    displayName: 'Evoplay',
    koreanName: '에보플레이',
    logoFile: 'vender-logo-evoplay.png',
    category: 'slot',
    aliases: ['evo play']
  },
  'cq9': {
    id: 'cq9',
    code: 'cq9',
    displayName: 'CQ9',
    koreanName: 'CQ9',
    logoFile: 'vender-logo-cq9.png',
    category: 'slot',
    aliases: ['cq9 gaming']
  },
  'habanero': {
    id: 'habanero',
    code: 'habanero',
    displayName: 'Habanero',
    koreanName: '하바네로',
    logoFile: 'vender-logo-habanero.png',
    category: 'slot',
    aliases: ['habanero systems']
  },
  'booongo': {
    id: 'booongo',
    code: 'booongo',
    displayName: 'Booongo',
    koreanName: '부운고',
    logoFile: 'vender-logo-booogo.png', // 파일명 주의
    category: 'slot',
    aliases: ['booongo gaming']
  },
  'pgsoft': {
    id: 'pgsoft',
    code: 'pgsoft',
    displayName: 'PG Soft',
    koreanName: 'PG 소프트',
    logoFile: 'vender-logo-pgsoft.png',
    category: 'slot',
    aliases: ['pg soft', 'pocket games soft']
  },
  'relax': {
    id: 'relax',
    code: 'relax',
    displayName: 'Relax Gaming',
    koreanName: '릴렉스 게이밍',
    logoFile: 'vender-logo-relaxgaming.png',
    category: 'slot',
    aliases: ['relaxgaming', 'relax gaming']
  },
  'hacksaw': {
    id: 'hacksaw',
    code: 'hacksaw',
    displayName: 'Hacksaw Gaming',
    koreanName: '핵쏘 게이밍',
    logoFile: 'vender-logo-hacksaw.png',
    category: 'slot',
    aliases: ['hacksaw gaming', 'hacksawgaming']
  },
  'jili': {
    id: 'jili',
    code: 'jili',
    displayName: 'JILI',
    koreanName: '질리',
    logoFile: 'vender-logo-jili.png',
    category: 'slot',
    aliases: ['jili games']
  },
  'playtech': {
    id: 'playtech',
    code: 'playtech',
    displayName: 'Playtech',
    koreanName: '플레이텍',
    logoFile: 'vender-logo-playtech.png',
    characterFile: '/api/providers/characters/casino-playtech.png',
    category: 'slot',
    aliases: ['play tech']
  },
  'nolimitcity': {
    id: 'nolimitcity',
    code: 'nolimitcity',
    displayName: 'Nolimit City',
    koreanName: '노리밋 시티',
    logoFile: 'vender-logo-nolimitcity.png',
    category: 'slot',
    aliases: ['no limit city', 'nolimit']
  },
  'thunderkick': {
    id: 'thunderkick',
    code: 'thunderkick',
    displayName: 'Thunderkick',
    koreanName: '썬더킥',
    logoFile: 'vender-logo-thunderkick.png',
    category: 'slot',
    aliases: ['thunder kick']
  },
  'quickspin': {
    id: 'quickspin',
    code: 'quickspin',
    displayName: 'Quickspin',
    koreanName: '퀵스핀',
    logoFile: 'vender-logo-quickspin.png',
    category: 'slot',
    aliases: ['quick spin']
  },
  'pushgaming': {
    id: 'pushgaming',
    code: 'pushgaming',
    displayName: 'Push Gaming',
    koreanName: '푸시 게이밍',
    logoFile: 'vender-logo-pushgaming.png',
    category: 'slot',
    aliases: ['push gaming', 'push']
  },
  
  // Live Casino Providers
  'evolution': {
    id: 'evolution',
    code: 'evolution',
    displayName: 'Evolution',
    koreanName: '에볼루션',
    logoFile: 'vender-logo-evolution.png',
    category: 'liveCasino',
    aliases: ['evolution gaming', 'evo']
  },
  'pragmaticlive': {
    id: 'pragmaticlive',
    code: 'pragmaticlive',
    displayName: 'Pragmatic Play Live',
    koreanName: '프라그마틱 플레이 라이브',
    logoFile: '/api/providers/logos/pragmaticlive.png',
    characterFile: '/api/providers/characters/casino-pragmaticlive.png',
    category: 'liveCasino',
    aliases: ['pragmatic live', 'pragmaticplaylive']
  },
  'ag': {
    id: 'ag',
    code: 'ag',
    displayName: 'Asia Gaming',
    koreanName: '아시아 게이밍',
    logoFile: 'vender-logo-ag.png',
    category: 'liveCasino',
    aliases: ['asia gaming', 'asiagaming', 'ag gaming']
  },
  'sexygaming': {
    id: 'sexygaming',
    code: 'sexygaming',
    displayName: 'Sexy Gaming',
    koreanName: '섹시 게이밍',
    logoFile: 'vender-logo-sexygaming.png',
    category: 'liveCasino',
    aliases: ['sexy gaming', 'sexy']
  },
  'wm': {
    id: 'wm',
    code: 'wm',
    displayName: 'WM',
    koreanName: 'WM',
    logoFile: 'vender-logo-wm.png',
    category: 'liveCasino',
    aliases: ['wm casino']
  },
  'gameplay': {
    id: 'gameplay',
    code: 'gameplay',
    displayName: 'Gameplay',
    koreanName: '게임플레이',
    logoFile: 'vender-logo-gameplay.png',
    category: 'liveCasino',
    aliases: ['game play']
  },
  'ezugi': {
    id: 'ezugi',
    code: 'ezugi',
    displayName: 'Ezugi',
    koreanName: '에즈기',
    logoFile: 'vender-logo-ezugi.png',
    category: 'liveCasino',
    aliases: ['ezugi gaming']
  },
  'vivo': {
    id: 'vivo',
    code: 'vivo',
    displayName: 'Vivo Gaming',
    koreanName: '비보 게이밍',
    logoFile: 'vender-logo-vivo.png',
    category: 'liveCasino',
    aliases: ['vivo gaming', 'vivogaming']
  },
  'allbet': {
    id: 'allbet',
    code: 'allbet',
    displayName: 'AllBet',
    koreanName: '올벳',
    logoFile: '/api/providers/logos/allbet.png',
    characterFile: '/api/providers/characters/casino-allbet.png',
    category: 'liveCasino',
    aliases: ['ALLBET', 'all bet']
  },
  'live88': {
    id: 'live88',
    code: 'live88',
    displayName: 'Live88',
    koreanName: '라이브88',
    logoFile: '/api/providers/logos/live88.png',
    characterFile: '/api/providers/characters/casino-live88.png',
    category: 'liveCasino',
    aliases: ['LIVE88', 'live 88']
  },
  'oriental': {
    id: 'oriental',
    code: 'oriental',
    displayName: 'Oriental Gaming',
    koreanName: '오리엔탈 게이밍',
    logoFile: '/api/providers/logos/oriental.png',
    characterFile: '/api/providers/characters/casino-oriental.png',
    category: 'liveCasino',
    aliases: ['ORIENTAL', 'orientalgaming', 'oriental gaming']
  },
  'superspade': {
    id: 'superspade',
    code: 'superspade',
    displayName: 'SuperSpade',
    koreanName: '슈퍼스페이드',
    logoFile: '/api/providers/logos/superspade.png',
    characterFile: '/api/providers/characters/casino-superspade.png',
    category: 'liveCasino',
    aliases: ['SUPERSPADE', 'super spade']
  },
  'xprogaming': {
    id: 'xprogaming',
    code: 'xprogaming',
    displayName: 'XPro Gaming',
    koreanName: '엑스프로 게이밍',
    logoFile: '/api/providers/logos/xprogaming.png',
    characterFile: '/api/providers/characters/casino-xprogaming.png',
    category: 'liveCasino',
    aliases: ['XPROGAMING', 'xpro gaming', 'xpro']
  },

  // Additional Providers (로고 파일은 있지만 한글명이 없던 것들)
  'macaw': {
    id: 'macaw',
    code: 'macaw',
    displayName: 'Macaw Gaming',
    koreanName: '마카우 게이밍',
    logoFile: 'vender-logo-macaw.png',
    category: 'slot',
    aliases: ['macaw gaming', 'macawgaming', 'Macaw', 'Macaw Gaming', 'MACAW']
  },
  'merkur': {
    id: 'merkur',
    code: 'merkur',
    displayName: 'Merkur',
    koreanName: '메르쿠르',
    logoFile: 'vender-logo-merkur.png',
    category: 'slot',
    aliases: ['merkur gaming']
  },
  'novomatic': {
    id: 'novomatic',
    code: 'novomatic',
    displayName: 'Novomatic',
    koreanName: '노보매틱',
    logoFile: 'vender-logo-novomatic.png',
    category: 'slot',
    aliases: ['novo matic']
  },
  'blueprint': {
    id: 'blueprint',
    code: 'blueprint',
    displayName: 'Blueprint',
    koreanName: '블루프린트',
    logoFile: 'vender-logo-blueprint.png',
    category: 'slot',
    aliases: ['blueprint gaming']
  },
  'boominggames': {
    id: 'boominggames',
    code: 'boominggames',
    displayName: 'Booming Games',
    koreanName: '부밍 게임즈',
    logoFile: 'vender-logo-boominggames.png',
    category: 'slot',
    aliases: ['booming games', 'booming']
  },
  'dragoonsoft': {
    id: 'dragoonsoft',
    code: 'dragoonsoft',
    displayName: 'Dragoonsoft',
    koreanName: '드라군소프트',
    logoFile: 'vender-logo-dragoonsoft.png',
    category: 'slot',
    aliases: ['dragoon soft']
  },
  'funky': {
    id: 'funky',
    code: 'funky',
    displayName: 'Funky Games',
    koreanName: '펑키 게임즈',
    logoFile: 'vender-logo-funky.png',
    category: 'slot',
    aliases: ['funky games', 'funkygames']
  },
  'kagaming': {
    id: 'kagaming',
    code: 'kagaming',
    displayName: 'KA Gaming',
    koreanName: 'KA 게이밍',
    logoFile: 'vender-logo-kagaming.png',
    category: 'slot',
    aliases: ['ka gaming', 'ka']
  },
  'simpleplay': {
    id: 'simpleplay',
    code: 'simpleplay',
    displayName: 'SimplePlay',
    koreanName: '심플플레이',
    logoFile: 'vender-logo-simpleplay.png',
    category: 'slot',
    aliases: ['simple play']
  },
  'skywind': {
    id: 'skywind',
    code: 'skywind',
    displayName: 'Skywind',
    koreanName: '스카이윈드',
    logoFile: 'vender-logo-skywind.png',
    characterFile: '/api/providers/characters/casino-skywind.png',
    category: 'slot',
    aliases: ['skywind group']
  },
  'solidgaming': {
    id: 'solidgaming',
    code: 'solidgaming',
    displayName: 'Solid Gaming',
    koreanName: '솔리드 게이밍',
    logoFile: 'vender-logo-solidgaming.png',
    category: 'slot',
    aliases: ['solid gaming', 'solid']
  },
  'wazdan': {
    id: 'wazdan',
    code: 'wazdan',
    displayName: 'Wazdan',
    koreanName: '와즈단',
    logoFile: 'vender-logo-wazdan.png',
    category: 'slot',
    aliases: ['WAZDAN']
  },
  'retrogames': {
    id: 'retrogames',
    code: 'retrogames',
    displayName: 'Retro Games',
    koreanName: '레트로 게임즈',
    logoFile: 'vender-logo-retrogames.png',
    category: 'slot',
    aliases: ['RETROGAMES', 'retro games']
  },
  'bet365': {
    id: 'bet365',
    code: 'bet365',
    displayName: 'Bet365',
    koreanName: '벳365',
    logoFile: 'vender-logo-bet365.png',
    category: 'slot',
    aliases: ['BET365']
  },

  // 추가 프로바이더들 - 슬롯/카지노
  '1x2gaming': {
    id: '1x2gaming',
    code: '1x2gaming',
    displayName: '1x2 Gaming',
    koreanName: '1x2게이밍',
    logoFile: 'vender-logo-1x2gaming.png',
    category: 'slot',
    aliases: ['1X2', '1x2gaming', '1X2GAMING', '1x2 gaming']
  },
  '7mojos': {
    id: '7mojos',
    code: '7mojos',
    displayName: '7mojos',
    koreanName: '세븐모조스',
    logoFile: 'vender-logo-7mojos.png',
    category: 'slot',
    aliases: ['7MOJOS', '7mojos', 'sevenmojos']
  },
  'amigo': {
    id: 'amigo',
    code: 'amigo',
    displayName: 'Amigo Gaming',
    koreanName: '아미고게이밍',
    logoFile: 'vender-logo-amigo.png',
    category: 'slot',
    aliases: ['AMIGO', 'amigo', 'amigogaming', 'AMIGOGAMING']
  },
  'aspectgaming': {
    id: 'aspectgaming',
    code: 'aspectgaming',
    displayName: 'Aspect Gaming',
    koreanName: '애스펙트게이밍',
    logoFile: 'vender-logo-aspectgaming.png',
    category: 'slot',
    aliases: ['ASPECT', 'aspectgaming', 'ASPECTGAMING', 'aspect gaming']
  },
  'avatarux': {
    id: 'avatarux',
    code: 'avatarux',
    displayName: 'AvatarUX',
    koreanName: '아바타UX',
    logoFile: 'vender-logo-avatarux.png',
    category: 'slot',
    aliases: ['AVATARUX', 'avatarux', 'avatar']
  },
  'betgames': {
    id: 'betgames',
    code: 'betgames',
    displayName: 'BetGames',
    koreanName: '벳게임즈',
    logoFile: 'vender-logo-betgames.png',
    category: 'liveCasino',
    aliases: ['BETGAMES', 'betgames', 'BetGames', 'bet games']
  },
  'bfgames': {
    id: 'bfgames',
    code: 'bfgames',
    displayName: 'BF Games',
    koreanName: 'BF게임즈',
    logoFile: 'vender-logo-bfgames.png',
    category: 'slot',
    aliases: ['BFGAMES', 'bfgames', 'BF', 'bf games']
  },
  'bgaming': {
    id: 'bgaming',
    code: 'bgaming',
    displayName: 'BGaming',
    koreanName: 'B게이밍',
    logoFile: 'vender-logo-bgaming.png',
    category: 'slot',
    aliases: ['BGAMING', 'bgaming', 'BG', 'b gaming']
  },
  'bigtimegaming': {
    id: 'bigtimegaming',
    code: 'bigtimegaming',
    displayName: 'Big Time Gaming',
    koreanName: '빅타임게이밍',
    logoFile: 'vender-logo-bigtimegaming.png',
    category: 'slot',
    aliases: ['BIGTIMEGAMING', 'bigtimegaming', 'BIGTIME', 'bigtime', 'big time gaming']
  },
  'boomerang': {
    id: 'boomerang',
    code: 'boomerang',
    displayName: 'Boomerang',
    koreanName: '부메랑',
    logoFile: 'vender-logo-boomerang.png',
    category: 'slot',
    aliases: ['BOOMERANG', 'boomerang']
  },
  'booming': {
    id: 'booming',
    code: 'booming',
    displayName: 'Booming',
    koreanName: '부밍',
    logoFile: 'vender-logo-booming.png',
    category: 'slot',
    aliases: ['BOOMING', 'booming']
  },
  'booogo': {
    id: 'booogo',
    code: 'booogo',
    displayName: 'Booongo',
    koreanName: '부운고',
    logoFile: 'vender-logo-booogo.png',
    category: 'slot',
    aliases: ['BOOOGO', 'booogo']
  },
  'caleta': {
    id: 'caleta',
    code: 'caleta',
    displayName: 'Caleta Gaming',
    koreanName: '칼레타게이밍',
    logoFile: 'vender-logo-caleta.png',
    category: 'slot',
    aliases: ['CALETA', 'caleta', 'caletagaming', 'CALETAGAMING']
  },
  'caletagaming': {
    id: 'caletagaming',
    code: 'caletagaming',
    displayName: 'Caleta Gaming',
    koreanName: '칼레타게이밍',
    logoFile: 'vender-logo-caletagaming.png',
    category: 'slot',
    aliases: ['CALETA', 'caleta', 'caletagaming', 'CALETAGAMING']
  },
  'dreamgame': {
    id: 'dreamgame',
    code: 'dreamgame',
    displayName: 'DreamGame',
    koreanName: '드림게임',
    logoFile: 'vender-logo-dreamgame.png',
    category: 'liveCasino',
    aliases: ['DREAMGAME', 'dreamgame', 'dreamgaming', 'DREAMGAMING', 'DREAM', 'DG', 'dream game']
  },
  'dreamtech': {
    id: 'dreamtech',
    code: 'dreamtech',
    displayName: 'DreamTech',
    koreanName: '드림테크',
    logoFile: 'vender-logo-dreamtech.png',
    category: 'slot',
    aliases: ['DREAMTECH', 'dreamtech', 'DT', 'dream tech']
  },
  'eagaming': {
    id: 'eagaming',
    code: 'eagaming',
    displayName: 'EA Gaming',
    koreanName: 'EA게이밍',
    logoFile: 'vender-logo-eagaming.png',
    category: 'liveCasino',
    aliases: ['EAGAMING', 'eagaming', 'EA', 'ea gaming']
  },
  'fantasma': {
    id: 'fantasma',
    code: 'fantasma',
    displayName: 'Fantasma',
    koreanName: '판타스마',
    logoFile: 'vender-logo-fantasma.png',
    category: 'slot',
    aliases: ['FANTASMA', 'fantasma', 'fantasma games']
  },
  'fatpanda': {
    id: 'fatpanda',
    code: 'fatpanda',
    displayName: 'Fat Panda',
    koreanName: '팻판다',
    logoFile: 'vender-logo-fatpanda.png',
    category: 'slot',
    aliases: ['FATPANDA', 'fatpanda', 'panda', 'fat panda']
  },
  'fils': {
    id: 'fils',
    code: 'fils',
    displayName: 'Fils',
    koreanName: '필스',
    logoFile: 'vender-logo-fils.png',
    category: 'slot',
    aliases: ['FILS', 'fils']
  },
  'funkygames': {
    id: 'funkygames',
    code: 'funkygames',
    displayName: 'Funky Games',
    koreanName: '펑키게임즈',
    logoFile: 'vender-logo-funkygames.png',
    category: 'slot',
    aliases: ['FUNKYGAMES', 'funkygames', 'FUNKY', 'funky', 'funky games']
  },
  'funtagaming': {
    id: 'funtagaming',
    code: 'funtagaming',
    displayName: 'Funta Gaming',
    koreanName: '펀타게이밍',
    logoFile: 'vender-logo-funtagaming.png',
    category: 'slot',
    aliases: ['FUNTAGAMING', 'funtagaming', 'FUNTA', 'funta', 'funta gaming']
  },
  'gameart': {
    id: 'gameart',
    code: 'gameart',
    displayName: 'GameArt',
    koreanName: '게임아트',
    logoFile: 'vender-logo-gameart.png',
    category: 'slot',
    aliases: ['GAMEART', 'gameart', 'GA', 'game art']
  },
  'gmw': {
    id: 'gmw',
    code: 'gmw',
    displayName: 'GMW',
    koreanName: 'GMW',
    logoFile: 'vender-logo-gmw.png',
    category: 'slot',
    aliases: ['GMW', 'gmw']
  },
  'greentube': {
    id: 'greentube',
    code: 'greentube',
    displayName: 'Greentube',
    koreanName: '그린튜브',
    logoFile: 'vender-logo-greentube.png',
    category: 'slot',
    aliases: ['GREENTUBE', 'greentube', 'GREEN', 'green tube']
  },
  'iconic': {
    id: 'iconic',
    code: 'iconic',
    displayName: 'Iconic',
    koreanName: '아이코닉',
    logoFile: 'vender-logo-iconic.png',
    category: 'slot',
    aliases: ['ICONIC', 'iconic']
  },
  'iconix': {
    id: 'iconix',
    code: 'iconix',
    displayName: 'Iconix',
    koreanName: '아이코닉스',
    logoFile: 'vender-logo-iconix.png',
    category: 'slot',
    aliases: ['ICONIX', 'iconix']
  },
  'intouch': {
    id: 'intouch',
    code: 'intouch',
    displayName: 'InTouch Games',
    koreanName: '인터치게임즈',
    logoFile: 'vender-logo-intouch.png',
    category: 'slot',
    aliases: ['INTOUCH', 'intouch', 'intouchgames', 'INTOUCHGAMES', 'in touch']
  },
  'intouchgames': {
    id: 'intouchgames',
    code: 'intouchgames',
    displayName: 'InTouch Games',
    koreanName: '인터치게임즈',
    logoFile: 'vender-logo-intouchgames.png',
    category: 'slot',
    aliases: ['INTOUCH', 'intouch', 'intouchgames', 'INTOUCHGAMES', 'in touch games']
  },
  'jdb': {
    id: 'jdb',
    code: 'jdb',
    displayName: 'JDB',
    koreanName: 'JDB',
    logoFile: 'vender-logo-jdb.png',
    category: 'slot',
    aliases: ['JDB', 'jdb']
  },
  'joker': {
    id: 'joker',
    code: 'joker',
    displayName: 'Joker Gaming',
    koreanName: '조커게이밍',
    logoFile: 'vender-logo-joker.png',
    category: 'slot',
    aliases: ['JOKER', 'joker', 'jokergaming', 'JOKERGAMING', 'joker gaming']
  },
  'kalamba': {
    id: 'kalamba',
    code: 'kalamba',
    displayName: 'Kalamba',
    koreanName: '칼람바',
    logoFile: 'vender-logo-kalamba.png',
    category: 'slot',
    aliases: ['KALAMBA', 'kalamba', 'kalamba games']
  },
  'mancala': {
    id: 'mancala',
    code: 'mancala',
    displayName: 'Mancala',
    koreanName: '만칼라',
    logoFile: 'vender-logo-mancala.png',
    category: 'slot',
    aliases: ['MANCALA', 'mancala', 'mancala gaming']
  },
  'mg': {
    id: 'mg',
    code: 'mg',
    displayName: 'MG',
    koreanName: 'MG',
    logoFile: 'vender-logo-mg.png',
    category: 'liveCasino',
    aliases: ['MG', 'mg']
  },
  'mplay': {
    id: 'mplay',
    code: 'mplay',
    displayName: 'MPlay',
    koreanName: '엠플레이',
    logoFile: 'vender-logo-mplay.png',
    category: 'slot',
    aliases: ['MPLAY', 'mplay', 'm play']
  },
  'nagagames': {
    id: 'nagagames',
    code: 'nagagames',
    displayName: 'Naga Games',
    koreanName: '나가게임즈',
    logoFile: 'vender-logo-nagagames.png',
    category: 'slot',
    aliases: ['NAGAGAMES', 'nagagames', 'NAGA', 'naga', 'naga games']
  },
  'netgame': {
    id: 'netgame',
    code: 'netgame',
    displayName: 'NetGame',
    koreanName: '넷게임',
    logoFile: 'vender-logo-netgame.png',
    category: 'slot',
    aliases: ['NETGAME', 'netgame', 'net game']
  },
  'netgaming': {
    id: 'netgaming',
    code: 'netgaming',
    displayName: 'NetGaming',
    koreanName: '넷게이밍',
    logoFile: 'vender-logo-netgaming.png',
    category: 'slot',
    aliases: ['NETGAMING', 'netgaming', 'net gaming']
  },
  'nextspin': {
    id: 'nextspin',
    code: 'nextspin',
    displayName: 'NextSpin',
    koreanName: '넥스트스핀',
    logoFile: 'vender-logo-nextspin.png',
    category: 'slot',
    aliases: ['NEXTSPIN', 'nextspin', 'NEXT', 'next spin']
  },
  'nolimit': {
    id: 'nolimit',
    code: 'nolimit',
    displayName: 'NoLimit',
    koreanName: '노리밋',
    logoFile: 'vender-logo-nolimit.png',
    category: 'slot',
    aliases: ['NOLIMIT', 'nolimit', 'no limit']
  },
  'octoplay': {
    id: 'octoplay',
    code: 'octoplay',
    displayName: 'OctoPlay',
    koreanName: '옥토플레이',
    logoFile: 'vender-logo-octoplay.png',
    category: 'slot',
    aliases: ['OCTOPLAY', 'octoplay', 'OCTO', 'octo play']
  },
  'petersons': {
    id: 'petersons',
    code: 'petersons',
    displayName: 'Petersons',
    koreanName: '피터슨스',
    logoFile: 'vender-logo-petersons.png',
    category: 'slot',
    aliases: ['PETERSONS', 'petersons']
  },
  'platingaming': {
    id: 'platingaming',
    code: 'platingaming',
    displayName: 'Platin Gaming',
    koreanName: '플라틴게이밍',
    logoFile: 'vender-logo-platingaming.png',
    category: 'slot',
    aliases: ['PLATINGAMING', 'platingaming', 'PLATIN', 'platin', 'platin gaming']
  },
  'platipus': {
    id: 'platipus',
    code: 'platipus',
    displayName: 'Platipus',
    koreanName: '플라티푸스',
    logoFile: 'vender-logo-platipus.png',
    category: 'slot',
    aliases: ['PLATIPUS', 'platipus']
  },
  'playson': {
    id: 'playson',
    code: 'playson',
    displayName: 'Playson',
    koreanName: '플레이손',
    logoFile: 'vender-logo-playson.png',
    category: 'slot',
    aliases: ['PLAYSON', 'playson']
  },
  'playstar': {
    id: 'playstar',
    code: 'playstar',
    displayName: 'PlayStar',
    koreanName: '플레이스타',
    logoFile: 'vender-logo-playstar.png',
    category: 'slot',
    aliases: ['PLAYSTAR', 'playstar', 'play star']
  },
  'popok': {
    id: 'popok',
    code: 'popok',
    displayName: 'Popok',
    koreanName: '포포크',
    logoFile: 'vender-logo-popok.png',
    category: 'slot',
    aliases: ['POPOK', 'popok']
  },
  'reelplay': {
    id: 'reelplay',
    code: 'reelplay',
    displayName: 'ReelPlay',
    koreanName: '릴플레이',
    logoFile: 'vender-logo-reelplay.png',
    category: 'slot',
    aliases: ['REELPLAY', 'reelplay', 'REEL', 'reel play']
  },
  'relaxgaming': {
    id: 'relaxgaming',
    code: 'relaxgaming',
    displayName: 'Relax Gaming',
    koreanName: '릴랙스게이밍',
    logoFile: 'vender-logo-relaxgaming.png',
    category: 'slot',
    aliases: ['RELAXGAMING', 'relaxgaming', 'relax gaming']
  },
  'revolver': {
    id: 'revolver',
    code: 'revolver',
    displayName: 'Revolver',
    koreanName: '리볼버',
    logoFile: 'vender-logo-revolver.png',
    category: 'slot',
    aliases: ['REVOLVER', 'revolver', 'revolver gaming']
  },
  'royalslot': {
    id: 'royalslot',
    code: 'royalslot',
    displayName: 'Royal Slot',
    koreanName: '로얄슬롯',
    logoFile: 'vender-logo-royalslot.png',
    category: 'slot',
    aliases: ['ROYALSLOT', 'royalslot', 'ROYAL', 'royal slot']
  },
  'rsg': {
    id: 'rsg',
    code: 'rsg',
    displayName: 'RSG',
    koreanName: 'RSG',
    logoFile: 'vender-logo-rsg.png',
    category: 'slot',
    aliases: ['RSG', 'rsg']
  },
  'rubyplay': {
    id: 'rubyplay',
    code: 'rubyplay',
    displayName: 'RubyPlay',
    koreanName: '루비플레이',
    logoFile: 'vender-logo-rubyplay.png',
    category: 'slot',
    aliases: ['RUBYPLAY', 'rubyplay', 'RUBY', 'ruby play']
  },
  'sexy': {
    id: 'sexy',
    code: 'sexy',
    displayName: 'Sexy Gaming',
    koreanName: '섹시게이밍',
    logoFile: 'vender-logo-sexy.png',
    category: 'liveCasino',
    aliases: ['SEXY', 'sexy']
  },
  'slotmatrix': {
    id: 'slotmatrix',
    code: 'slotmatrix',
    displayName: 'Slot Matrix',
    koreanName: '슬롯매트릭스',
    logoFile: 'vender-logo-slotmatrix.png',
    category: 'slot',
    aliases: ['SLOTMATRIX', 'slotmatrix', 'MATRIX', 'slot matrix']
  },
  'slotmill': {
    id: 'slotmill',
    code: 'slotmill',
    displayName: 'Slot Mill',
    koreanName: '슬롯밀',
    logoFile: 'vender-logo-slotmill.png',
    category: 'slot',
    aliases: ['SLOTMILL', 'slotmill', 'MILL', 'slot mill']
  },
  'theplayer': {
    id: 'theplayer',
    code: 'theplayer',
    displayName: 'The Player',
    koreanName: '더플레이어',
    logoFile: 'vender-logo-theplayer.png',
    category: 'slot',
    aliases: ['THEPLAYER', 'theplayer', 'PLAYER', 'the player']
  },
  'wn': {
    id: 'wn',
    code: 'wn',
    displayName: 'WN',
    koreanName: 'WN',
    logoFile: 'vender-logo-wn.png',
    category: 'slot',
    aliases: ['WN', 'wn']
  },
  'xpans': {
    id: 'xpans',
    code: 'xpans',
    displayName: 'XPans',
    koreanName: '엑스팬스',
    logoFile: 'vender-logo-xpans.png',
    category: 'slot',
    aliases: ['XPANS', 'xpans']
  },
  'ygr': {
    id: 'ygr',
    code: 'ygr',
    displayName: 'YGR',
    koreanName: 'YGR',
    logoFile: 'vender-logo-ygr.png',
    category: 'slot',
    aliases: ['YGR', 'ygr']
  },
  'yolted': {
    id: 'yolted',
    code: 'yolted',
    displayName: 'Yolted',
    koreanName: '욜티드',
    logoFile: 'vender-logo-yolted.png',
    category: 'slot',
    aliases: ['YOLTED', 'yolted']
  },
  'aggaming': {
    id: 'aggaming',
    code: 'aggaming',
    displayName: 'AG Gaming',
    koreanName: 'AG게이밍',
    logoFile: 'vender-logo-aggaming.png',
    category: 'liveCasino',
    aliases: ['AGGAMING', 'aggaming', 'ag gaming']
  },
  'amigogaming': {
    id: 'amigogaming',
    code: 'amigogaming',
    displayName: 'Amigo Gaming',
    koreanName: '아미고게이밍',
    logoFile: 'vender-logo-amigogaming.png',
    category: 'slot',
    aliases: ['AMIGOGAMING', 'amigogaming', 'amigo gaming']
  }
};

/**
 * 프로바이더 검색 함수
 * ID, 코드, 표시명, 별칭으로 프로바이더를 찾을 수 있음
 * @param {string} nameOrId - 찾을 프로바이더 이름 또는 ID
 * @returns {Object|null} 프로바이더 객체 또는 null
 */
export function getProvider(nameOrId) {
  if (!nameOrId) return null;
  
  // ID로 직접 검색 (대소문자 구분 없이)
  const lowerNameOrId = nameOrId.toLowerCase();
  if (PROVIDERS[lowerNameOrId]) {
    return PROVIDERS[lowerNameOrId];
  }
  
  // 정규화된 이름으로 검색
  const normalized = nameOrId.toLowerCase().replace(/['\s-]/g, '');
  
  // 모든 프로바이더를 순회하며 검색
  for (const [id, provider] of Object.entries(PROVIDERS)) {
    // ID 매칭
    if (id === normalized) {
      return provider;
    }
    
    // 코드 매칭
    if (provider.code === normalized) {
      return provider;
    }
    
    // Display Name 매칭
    if (provider.displayName.toLowerCase().replace(/['\s-]/g, '') === normalized) {
      return provider;
    }
    
    // Alias 매칭
    if (provider.aliases && provider.aliases.some(alias => 
      alias.toLowerCase().replace(/['\s-]/g, '') === normalized
    )) {
      return provider;
    }
  }
  
  return null;
}

/**
 * 카테고리별 프로바이더 목록 가져오기
 * @param {string} category - 카테고리 ('slot', 'liveCasino', 등)
 * @returns {Array} 해당 카테고리의 프로바이더 배열
 */
export function getProvidersByCategory(category) {
  return Object.values(PROVIDERS).filter(provider => provider.category === category);
}

/**
 * 모든 프로바이더 목록 가져오기
 * @returns {Array} 모든 프로바이더 배열
 */
export function getAllProviders() {
  return Object.values(PROVIDERS);
}